<main class="verification-failed">
  <section class="verification-failed__card" aria-labelledby="expired-title">
    <span class="verification-failed__status">
      <i class="pi pi-exclamation-circle"></i>
      Link Expired
    </span>

    <h1 id="expired-title">This activation link has expired</h1>

    <p>
      For security reasons, invitation links are valid for 24 hours only. Please
      reach out to your administrator to request a new invitation.
    </p>

    <div class="verification-failed__admin" aria-label="Administrator contact">
      <span class="verification-failed__admin-label">Your Administrator</span>
      <strong>Mohamed Nasr</strong>

      <div class="verification-failed__contact-row mb-3">
        <div class="icon-wrapper">
          <i class="pi pi-envelope" aria-hidden="true"></i>
        </div>
        <span>{{ adminEmail }}</span>
        <button
          type="button"
          aria-label="Copy administrator email"
          (click)="copyText(adminEmail, 'email')"
        >
          @if(copiedField === 'email') {
          <i class="pi pi-check"></i>
          } @else {
          <i class="pi pi-clone"></i>
          }
        </button>
      </div>

      <div class="verification-failed__contact-row">
        <div class="icon-wrapper">
          <i class="pi pi-phone" aria-hidden="true"></i>
        </div>
        <span>{{ adminPhone }}</span>
        <button
          type="button"
          aria-label="Copy administrator phone"
          (click)="copyText(adminPhone, 'phone')"
        >
          @if(copiedField === 'phone') {
          <i class="pi pi-check"></i>
          } @else {
          <i class="pi pi-clone"></i>
          }
        </button>
      </div>
    </div>
  </section>
</main>
